"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputFooterText = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _text = require("../../text");
var _react2 = require("@emotion/react");
const InputFooterText = _ref => {
  let {
    children,
    variant = _text.TextVariant.BodySM,
    ...transferProps
  } = _ref;
  return (0, _react2.jsx)(_text.Text, (0, _extends2.default)({
    variant: variant,
    color: (0, _utils.token)('color.text.secondary')
  }, transferProps), children);
};
exports.InputFooterText = InputFooterText;
InputFooterText.displayName = 'InputFooterText';
InputFooterText.propTypes = {
  ..._text.Text.propTypes
};
var _default = exports.default = InputFooterText;